import { createActions } from '../utils/actions';

import studioPhotos from './studio.photos';
import studioVideos from './studio.videos';

const { actions: studio } = createActions('studio')
  .addAsync('uploadFiles');

studio.photos = studioPhotos;
studio.videos = studioVideos;

export default studio;
